module.exports = __webpack_public_path__ + "static/img/159851959.950d8c69.png";